var NoData = "No data";
var enLang = {
	"Chọn": "Select",
	NoData: NoData
};

export { NoData, enLang as default };
